module.exports = __webpack_public_path__ + "static/media/menu-close.d227b245.svg";